import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "login-page flex-center"
};
const _hoisted_2 = {
  class: "login-panel flex box-sizing"
};
const _hoisted_3 = {
  class: "login-action flex-full box-sizing"
};
const _hoisted_4 = {
  class: "tabs"
};
const _hoisted_5 = {
  class: "content"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import panelCompany from './components/panel-company.vue';
import accoutAction from './components/accout-action.vue';
import phoneAction from './components/phone-action.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const tabsActive = ref('accout');
    onMounted(() => {
      document.title = 'AI扫食 - 登录';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(panelCompany), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "text flex-center"
      }, "员工登录", -1)), _createElementVNode("div", _hoisted_5, [tabsActive.value === 'phone' ? (_openBlock(), _createBlock(phoneAction, {
        key: 0
      })) : _createCommentVNode("", true), tabsActive.value === 'accout' ? (_openBlock(), _createBlock(accoutAction, {
        key: 1
      })) : _createCommentVNode("", true)])])])])]);
    };
  }
});